<template>
<span>
  <b-dropdown right>
    <template v-slot:button-content>
      <img src="https://img.icons8.com/ios-glyphs/16/ffffff/email.png"/>
      Email
    </template>
    <b-dropdown-item @click="composeFollowUp()">Thank you for your time</b-dropdown-item>
    <b-dropdown-item @click="composeAttempt()">Tried to reach you</b-dropdown-item>
    <b-dropdown-divider></b-dropdown-divider>
    <b-dropdown-item @click="composeBlank()">Blank</b-dropdown-item>
  </b-dropdown>
  <b-modal ref="composer" title="Send Email" ok-title="Send" @ok="sendEmail" :busy="sending">
    <b-form-group label="Subject">
      <b-form-input v-model="subject"></b-form-input>
    </b-form-group>
    <b-form-group label="Body">
      <vue-editor id="editor" v-model="body"></vue-editor>
    </b-form-group>
  </b-modal>
</span>
</template>
<script>
import $office from '@/services/office';
import $auth from '@/services/auth';
import { VueEditor } from 'vue2-editor';
import { InsertClientEmail } from '@/gql/members/Emails.gql';
import MemberEmailButton from '@/components/members/MemberEmailButton';
import opportunities from '@/config/opportunities.json';

export default {
  components: {
    MemberEmailButton,
    VueEditor,
  },
  props: {
    member: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      subject: '',
      body: '',
      sending: false
    };
  },
  methods: {
    composeFollowUp() {
      let body = `<p>Hi ${this.member.name}!</p>
      <p>It was a pleasure to speak with you just now. As discussed, please find below links to sign up for some of our key initiatives:</p>
      `;
      Object.values(opportunities).forEach((opportunity) => {
        let link = `${opportunity.link}?email=${encodeURIComponent(this.member.email)}&name=${encodeURIComponent(this.member.name)}`;
        body += `<h4><a href="${link}">${opportunity.title}</a></h4><p>${opportunity.description}</p>
        `;
      });
      body += `<p>If you have any questions, please don't hesitate to send me an email. I look forward to connecting you with further over time.</p>
      `;
      body += `<p>${$auth.getUser().name}</p>`;
      body += `<p>Community Connector @ <a href="https://www.csuitecircle.com">C-Suite Circle</a></p>`;
      this.body = body;
      this.subject = 'CEO Network - Follow Up';
      this.$refs.composer.show();
    },
    composeAttempt() {
      let body = `<p>Hi ${this.member.name}!</p>
      <p>I'm one of the Community Managers at C-Suite Circle - you recently joined our CEO network via LinkedIn.</p>
      <p>I just tried to give you a call to welcome you to the network, but wasn't able to get through.</p>
      <p>I will try again tomorrow, although if you prefer you can schedule a time that works for you via <a href="https://calendly.com/csuitecircle/ceo-network-welcome-call">this link</a>.</p>
      <p>I look forward to connecting with you soon.</p>
      <p>${$auth.getUser().name}</p><p>Community Connector @ <a href="https://www.csuitecircle.com">C-Suite Circle</a></p>`;
      this.body = body;
      this.subject = 'CEO Network Welcome Call';
      this.$refs.composer.show();
    },
    composeBlank() {
      let body = `<p>Hi ${this.member.name}!</p>
      <p>${$auth.getUser().name}</p><p>Community Connector @ <a href="https://www.csuitecircle.com">C-Suite Circle</a></p>`;
      this.body = body;
      this.subject = '';
      this.$refs.composer.show();
    },
    async sendEmail(evt) {
      evt.preventDefault();
      this.sending = true;
      await $office.send(this.member.email, this.subject, this.body);
      let resp = await this.$apollo.mutate({
        mutation: InsertClientEmail,
        variables: {
          body: this.body,
          subject: this.subject,
          to: this.member.email,
          toId: this.member.id,
          from: $auth.getUserId()
        }
      });
      this.sending = false;
      this.$refs.composer.hide();
    },
  },
};
</script>
<style scoped>
  #editor .ql-editor
  {
    height:300px;
  }
</style>
